import React, { useEffect, useState } from 'react';
import styles from './PassResetByEmail.module.scss';
import { ReactComponent as IconBack } from 'images/icons/go-back.svg';
import { ReactComponent as Message } from 'images/new-icons/Message.svg';
import { ReactComponent as Success } from 'images/new-icons/Exactly.svg';
import Button from 'components/shared/Button';
import supabase from 'sdk/api';
import { useNavigate } from 'react-router-dom';

const PassResetByEmail = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState('');

  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    setIsLoading(true);
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/password-reset/new-pass`,
    });

    if (error) {
      if (error.message.includes('email rate limit exceeded')) {
        setError('Too many requests on password reset. Please try again later.');
      } else {
        setError(error.message);
      }

      setIsLoading(false);
    } else {
      console.log('success');
      setError('');
      setIsLoading(false);
      setIsSuccess(true);
    }
  };

  const handleOpenEmail = () => {
    // Список популярных почтовых сервисов
    const emailClients = {
      gmail: 'https://mail.google.com',
      outlook: 'https://outlook.live.com',
      yahoo: 'https://mail.yahoo.com',
    };

    // Определяем домен email пользователя
    const emailDomain = email?.split('@')[1];

    // Открываем соответствующий почтовый клиент или общий mailto:
    if (emailDomain?.includes('gmail')) {
      window.location.href = emailClients.gmail;
    } else if (emailDomain?.includes('outlook') || emailDomain?.includes('hotmail')) {
      window.location.href = emailClients.outlook;
    } else if (emailDomain?.includes('yahoo')) {
      window.location.href = emailClients.yahoo;
    } else {
      window.location.href = 'mailto:';
    }
  };

  useEffect(() => {
    if (email) {
      setError('');
    }
  }, [email]);

  return (
    <>
      <form action="" className={styles.form} onSubmit={e => handleSubmit(e)}>
        <div className={styles.passResetByEmail}>
          <div className={styles.passResetByEmail__back}>
            <IconBack onClick={() => navigate(-1)} />
          </div>
          <div className={styles.passResetByEmail__title}>Password Recovery</div>
          <div className={styles.passResetByEmail__none}></div>
        </div>
        <div
          className={styles.passInput}
          style={{
            border: error ? '1px solid #FF3B30' : '1px solid #01010180',
          }}
        >
          <Message />
          <input
            type={'email'}
            value={email}
            onChange={(e: React.FormEvent<HTMLInputElement>) => {
              const target = e.target as HTMLInputElement;
              const value = target?.value;
              setEmail(value);
            }}
            placeholder="Email Address"
          />
        </div>
        {error && (
          <div
            style={{
              color: '#FF3B30',
              fontSize: '12px',
              textAlign: 'center',
              fontFamily: 'Graphik Light',
              fontWeight: '400',
            }}
          >
            {error}
          </div>
        )}
        <Button wide darkGreen type="submit" disabled={!email} loading={isLoading}>
          Next
        </Button>
      </form>
      {isSuccess && (
        <div className={styles.success}> 
          <div className={styles.success__inner}>
               <div className={styles.success__back}>
 <div className={styles.close_btn} onClick={() => setIsSuccess(false)}>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <line x1="18" y1="6" x2="6" y2="18" stroke="white" strokeWidth="2" strokeLinecap="round" />
          <line x1="6" y1="6" x2="18" y2="18" stroke="white" strokeWidth="2" strokeLinecap="round" />
        </svg>
      </div>

          </div>
            <Success />
            <div>Success</div>
            <div>Follow the link in your email to confirm</div>
            <Button wide darkGreen onClick={handleOpenEmail}>
              Open email
            </Button>
          </div>
        </div>
      )}
    </>
  );
};

export default PassResetByEmail;
